import { render, staticRenderFns } from "./SelectTabMaterial.vue?vue&type=template&id=76ec3f1c&scoped=true"
import script from "./SelectTabMaterial.vue?vue&type=script&lang=js"
export * from "./SelectTabMaterial.vue?vue&type=script&lang=js"
import style0 from "./SelectTabMaterial.vue?vue&type=style&index=0&id=76ec3f1c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ec3f1c",
  null
  
)

export default component.exports